var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 25.5","name":"gc-arrow-down"}},[_c('path',{style:({
      stroke: _vm.color
    }),attrs:{"fill":"none","stroke-width":"3","stroke-linecap":"straight","stroke-linejoin":"straight","stroke-miterlimit":"10","d":"M25.1 9.5l-8 8-8-8"}})])}
var staticRenderFns = []

export { render, staticRenderFns }